import { render, staticRenderFns } from "./adminClientProfile.vue?vue&type=template&id=4071f111&scoped=true&"
import script from "./adminClientProfile.vue?vue&type=script&lang=js&"
export * from "./adminClientProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4071f111",
  null
  
)

export default component.exports